/**
 * Whether saving an obligation of this Source should PATCH an existing row (explicit Dataverse rows
 * and Cosmos rows — the backend routes the latter to Cosmos) versus POST a new explicit row (derived
 * synthesis overrides and brand-new obligations). Kept in its own module so the dialog component file
 * only exports components (react-refresh). Exported for unit testing the routing decision.
 */
export function obligationSubmitsViaPatch(source?: string): boolean {
  return source === 'explicit' || source === 'cosmos';
}
